module.exports = __webpack_public_path__ + "static/media/login_top_back.eb162022.svg";